module.exports = __webpack_public_path__ + "static/img/ewm.6bf5275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ewm.png
// module id = 290
// module chunks = 1